import { Component, Input } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
    selector: 'spv2-grid-legal-entity-filter',
    templateUrl: './grid-legal-entity-filter.component.html',
    styleUrls: ['./grid-legal-entity-filter.component.scss'],
    standalone: false
})
export class GridLegalEntityFilterComponent extends GridFilterBase<string> {
  @Input() companyId : string;
}